import { tw } from "@careinfo/tailwind";
import { useFormContext } from "react-hook-form";
import CodeField from "../../shared/CodeField";
import TextField from "../../shared/TextField";
import { IComponent } from "../../types/interface";

export default function ComponentForm() {
  const { control } = useFormContext<IComponent>();

  return (
    <div className={tw`space-y-2`}>
      <TextField
        control={control}
        disabled={true}
        name="name"
        placeholder="Enter name of navigation"
        label="Name"
      />

      <CodeField control={control} name="content" label="Content" />
    </div>
  );
}
